import APIS from "../../constant/EndPoint";
import { classNames } from "../../utils/classNames";
import useGetHook from "../../customHooks/useGetHook";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect } from "react";
import ComboboxInput from "../Reusable/ComboboxInput";
import CheckBox from "../Reusable/CheckBox";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import DateRangePicker from "../Reusable/DateRangePicker";
const animatedComponents = makeAnimated();
const ConsignmentFilter = (props: any) => {
  const {
    register,
    errors,
    setValue,
    getValues,
    reset,
    watch,
    clearErrors,
    defaultValue,
    setDefaultValue,
  } = props;

  const { data: statusList } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: { is_active: true },
  });

  const onChange = (value: any) => {
    setValue("delivery_status__in", value);
    setDefaultValue(value);
  };

  useEffect(() => {
    if (!defaultValue) {
      setDefaultValue(watch("delivery_status__in"));
    }
  }, [watch("status")]);

  return (
    <div
      className={classNames(
        props?.isFilterVisible ? tw`block` : tw`hidden`,
        tw`relative`
      )}
    >
      <div className={tw`grid grid-cols-4 gap-x-4 mx-4`}>
        <DateRangePicker
          label={"Select Date Range"}
          setValue={setValue}
          name={"created__range"}
          getValues={getValues}
        />
        <ComboboxInput
          url={APIS.BRANCH}
          queryKey={"barnch"}
          register={register("pickup_branch")}
          errors={errors?.pickup_branch}
          name={"pickup_branch"}
          label={"Pickup Branch"}
          setValue={setValue}
          placeholder={"Select Pickup Branch"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.LOCATION}
          props={{ level: 3, is_active: true }}
          queryKey={"city"}
          register={register("destination")}
          errors={errors?.destination}
          name={"destination"}
          label={"Select Destination City"}
          setValue={setValue}
          placeholder={"Select Destination City"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <div className={tw`mt-3`}>
          <label htmlFor="" className={tw`block mb-3`}>
            Status
          </label>
          <Select
            value={defaultValue}
            components={animatedComponents}
            closeMenuOnSelect={false}
            options={statusList}
            onChange={onChange}
            isMulti
          />
        </div>
      </div>
      <button className={tw`absolute -top-5 right-5`} onClick={() => reset()}>
        Reset
      </button>
    </div>
  );
};

export default ConsignmentFilter;
